import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// Utils
import analyticsUtil from '../util/analytics-util';

export class EntityTermsAndConditionsController implements Controller {
  public pageId = 'page.affhub.entity.terms';
  public path = '/:localeName/entity-terms-and-conditions';
  public routeName = 'entity-terms-and-conditions';
  public bundles = [];

  public component = codeSplit(
    () =>
      import(/* webpackChunkName: "entity-terms-and-conditions-page" */ '../views/entity-terms-and-conditions-page'),
  );
  public exact = true;

  public fetch(options: FetchOptions): Promise<Result> {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Terms & Conditions' }) as Promise<PageData>;
  }
}
